export default __webpack_public_path__ + "media/zurb/img/home/SAP-7d68aa577ce241ccdc4ef56ef3be2d41.png";